import { GameConfig } from "@/config/GameConfig";

export interface ScoreHitResult {
  previousScore: number;
  newScore: number;
  /** `newScore - previousScore`, always <= 0. */
  delta: number;
  /** True if the flat-loss rule applied (score <= threshold); false if the percentage rule applied. */
  wasFlat: boolean;
  /** The configured percentage-above-threshold loss, for display when `!wasFlat`. */
  percent: number;
}

/**
 * The SCORE HIT rule, as a pure function of the current score: at or
 * below the threshold, subtract a flat amount; above it, keep only a
 * fraction (floored). Deliberately never clamped at 0 in either branch -
 * CHAOS must always have a real effect, even on a broke or already
 * negative score - so the result can go negative.
 */
export function computeScoreHit(currentScore: number): ScoreHitResult {
  const { threshold, flatLoss, percentAbove } = GameConfig.bites.chaos.scoreHit;
  const wasFlat = currentScore <= threshold;
  const newScore = wasFlat ? currentScore - flatLoss : Math.floor(currentScore * (1 - percentAbove));
  return {
    previousScore: currentScore,
    newScore,
    delta: newScore - currentScore,
    wasFlat,
    percent: Math.round(percentAbove * 100),
  };
}
